import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Button, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IBackButtonProps } from './types';
import { AuthTabs } from '../../../../common/enums/auth';

export const BackButton: React.FC<IBackButtonProps> = ({
  setActiveTab = null,
  setIsForgotPassword = null,
  text = null,
  skipReloadPage = false,
  customClickFn = null,
}) => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    if (customClickFn) {
      customClickFn();
      return;
    }

    if (setActiveTab) {
      if (setIsForgotPassword) setIsForgotPassword(false);
      setActiveTab(AuthTabs.SIGN_IN);

      return;
    }

    let stepsBack = -1;

    if (skipReloadPage) {
      navigate(stepsBack);
      return;
    }

    let previousUrl = document.referrer;

    while (previousUrl && !previousUrl.includes(window.location.origin)) {
      stepsBack--;
      previousUrl = '';
    }

    if (previousUrl.includes(window.location.origin)) {
      navigate(stepsBack);
    } else {
      navigate('/');
    }
  };

  if (text)
    return (
      <Button variant="text" color="primary" onClick={handleBackClick}>
        {text}
      </Button>
    );

  return (
    <IconButton
      aria-label="back button"
      size={'large'}
      onClick={handleBackClick}
      sx={{ alignSelf: 'flex-start' }}
    >
      <ArrowBackIosNewIcon color={'success'} />
    </IconButton>
  );
};
